import type { FC } from 'react';
import { AdsHistory } from 'features/cabinet';
import { CabinetTitlePage } from 'components/layout';
import { Guard, usePermissionGuard } from 'features/login';

const AdsHistoryPage: FC = () => {
  const { accessToViewAdlog } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToViewAdlog} fallback>
      <CabinetTitlePage title={'Ads History'} />
      <AdsHistory />
    </Guard>);
};

export default AdsHistoryPage;
